import React, { useContext, useEffect, useState } from 'react'
import {AiFillCloseCircle} from 'react-icons/ai'
import {IoMdArrowDropdown} from 'react-icons/io'
import {IoChevronBackOutline, IoClose} from  'react-icons/io5'
import {BiCheck, BiEdit} from  'react-icons/bi'

import Renderif from '../../components/renderif'
import DropDown, { DropDownOption } from '../../components/dropdown'
import BVCalendar from '../../components/calendar'
import { Service } from '../../services/api'
import { AuthContext } from '../../context/auth_context'

import ApiCalendar from "react-google-calendar-api";
import { AlertContext } from '../../context/alert_context'
import Loader from '../../components/loader'
import { primary } from '../../utils/colors'
import { GoStarFill } from 'react-icons/go'
import { useNavigate } from 'react-router-dom'


export default function EspecialistaCard({onClose = () =>{}}) {
    
    const navigate = useNavigate();

    let date = new Date();
    date.setDate(date.getDate() + 1)

    const {user} = useContext(AuthContext)
    const {notify} = useContext(AlertContext)
    const [state, setState] = useState({
        step:0,
        selected_date:null,
        specialists:[],
        specialists_pisco:[],
        specialists_couch:[],
        selected_speciality:null,
        selected_specialist:null,
        selected_day:date,
        selected_time:'',
        selected_daytime:null,
        description:'',
        loading:false

    })
    useEffect(()=>{
        
       
        const init = async () => {
      
        }
        init()

        return () => {}
        
    },[])

   
 
    var arr = [
        '09:00',
        '10:00',
        '11:00',
        '12:00',
        '13:00',
        '14:00',
        '15:00',
        '16:00',
        '17:00',
    ]

    var weekday=new Array(7);
    weekday[0]="Sunday";
    weekday[1]="Monday";
    weekday[2]="Tuesday";
    weekday[3]="Wednesday";
    weekday[4]="Thursday";
    weekday[5]="Friday";
    weekday[6]="Saturday";

    var months=new Array(7);
    months[0]="January";
    months[1]="Febrary";
    months[2]="March";
    months[3]="April";
    months[4]="May";
    months[5]="June";
    months[6]="July";
    months[7]="August";
    months[8]="September";
    months[9]="Octuber";
    months[10]="November";
    months[11]="December";


  return (
    <>
     <Renderif isTrue={state.loading === true}>
      <Loader></Loader>
    </Renderif>
    <div className='overlay d-flex justify-content-center align-items-center'>

        
            <div className='bv-modal bv-modal--card shadow'>

                <div className='d-flex  p-3'>
                    
                    <div className='d-flex align-items-center'>
                        <div className='avatar avatar--mid me-2'></div>
                        <div className='d-flex flex-column'>
                                <div className='f-16 bold line-0'>Nombre Apellido</div>
                                <div className='f-14 text-gray'>correo@correo.com</div>
                        </div>
                    </div>
                    <div className='col'></div>
                    <div className='bv-icon bv-icon--mid cursor-pointer' onClick={()=>{
                        onClose()
                    }}>
                        <IoClose size={30} color={primary}></IoClose>
                    </div>


                </div>

                <div className='d-flex mt-3 '>
                    <div className='col ps-4'>

                        <div className='d-flex align-items-center'>

                            <div className='bv-icon bv-icon--big bg-lightblue r-5 me-3'>
                                <BiEdit size={30} color='#3699FF'></BiEdit>
                            </div>

                            <div>
                                <div className='text-dark f-16 bold'>$320</div>
                                <div className='text-gray f-14 line-0'>Plan Basico</div>
                            </div>
                            
                        </div>
                    </div>

                    <div className='col'>
                        <div className='d-flex align-items-center'>

                            <div className='bv-icon bv-icon--big bg-lightred r-5 me-3'>
                                <BiEdit size={30} color='#F64E60'></BiEdit>
                            </div>

                            <div>
                                <div className='text-dark f-16 bold'>$1,432</div>
                                <div className='text-gray f-14 line-0'>Plan Premium</div>
                            </div>
                            
                        </div>
                    </div>
                </div>

                <div className='d-flex my-3'>
                    <div className='col ps-4'>

                        <div className='d-flex align-items-center'>

                            <div className='bv-icon bv-icon--big bg-lightgreen r-5 me-3'>
                                <BiEdit size={30} color='#0BB783'></BiEdit>
                            </div>

                            <div>
                                <div className='text-dark f-16 bold'>582</div>
                                <div className='text-gray f-14 line-0'>Sesion Extra</div>
                            </div>
                            
                        </div>
                    </div>
                    <div className='col'>
                        <div className='d-flex align-items-center'>

                            <div className='bv-icon bv-icon--big bg-lightpurple r-5 me-3'>
                                <BiEdit size={30} color='#8950FC'></BiEdit>
                            </div>

                            <div>
                                <div className='text-dark f-16 bold'>$32,230</div>
                                <div className='text-gray f-14 line-0'>Plan Gratuito</div>
                            </div>
                            
                        </div>
                    </div>
                </div>

                <div className='d-flex px-4 mt-5'>                    
                    <div className='col'> 
                        <div className='d-flex align-items-center'>
                            <div className='f-12 text-gray bold px-1'>5</div>
                            <div className='bar'>
                                <div className='bar-value' style={{width:'100%'}}></div>
                            </div>
                        </div>
                        <div className='d-flex align-items-center'>
                            <div className='f-12 text-gray bold px-1'>4</div>
                            <div className='bar'>
                                <div className='bar-value' style={{width:'80%'}}></div>
                            </div>
                        </div>
                        <div className='d-flex align-items-center'>
                            <div className='f-12 text-gray bold px-1'>3</div>
                            <div className='bar'>
                                <div className='bar-value' style={{width:'60%'}}></div>
                            </div>
                        </div>
                        <div className='d-flex align-items-center'>
                            <div className='f-12 text-gray bold px-1'>2</div>
                            <div className='bar'>
                                <div className='bar-value' style={{width:'40%'}}></div>
                            </div>
                        </div>
                        <div className='d-flex align-items-center'>
                            <div className='f-12 text-gray bold px-1'>1</div>
                            <div className='bar'>
                                <div className='bar-value' style={{width:'20%'}}></div>
                            </div>
                        </div>
                    </div>
                    <div className='px-3'>
                        <div className='d-flex align-items-center'>
                            <div>4.5</div>
                            <div className='bv-icon bv-icon--mid'>
                                <GoStarFill color='#FFA800'></GoStarFill>
                            </div>
                        </div>
                        <div className='f-12 text-gray'>232 reseñas</div>
                        <div className='f-12 text-gray'>85% recomendado.</div>
                    </div>
                </div>

                <div className='f-14 text-primary text-center text-decoration-underline cursor-pointer my-4 ' onClick={()=>{
                    navigate('/administrador/valoraciones')
                }}>Ver comentarios</div>
                <div className='f-10 text-gray px-4'>Gestiona con facilidad todas las reseñas, asegurándote de que cada interacción refleje la excelencia de tu producto o servicio</div>

                <div className='my-4'></div>

            </div>
        
    
    </div>
    </>
  )
}
